export default __webpack_public_path__ + "static/media/Inter-Thin.5b7f1750.woff2";